import React, { useEffect, useState } from "react";
import axios from "axios";
import { Check, Loader2, Package } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const GOLD = "#d7bb7a";
const CREAM = "#f5ecd9";

// Golf Season Pack: one tap saves every golf installation to the member's library.
export const GolfPackButton = ({ className = "" }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => { axios.get(`${API}/api/audio-journeys/packs/golf`, auth()).then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const done = s.in_library >= s.total;
  const add = async () => {
    setBusy(true); setMsg("");
    try { const { data } = await axios.post(`${API}/api/audio-journeys/packs/golf`, {}, auth()); setS(data); setMsg(`${data.added} added to your library`); }
    catch { setMsg("Couldn't add the pack just now. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <div className={`rounded-3xl p-5 ${className}`} style={{ border: `1px solid ${GOLD}66`, background: "linear-gradient(135deg, rgba(215,187,122,0.14), rgba(13,31,58,0.5))" }} data-testid="golf-pack">
      <p className="text-[0.6rem] uppercase tracking-[0.32em]" style={{ color: GOLD, fontFamily: '"Manrope", sans-serif' }}>Golf Season Pack</p>
      <p className="mt-2 text-xl font-light leading-snug" style={{ fontFamily: '"Cormorant Garamond", serif', color: CREAM }}>
        All {s.total} golf installations, from the first tee to the overnight round, in one tap. Includes Overnight · Golf-Ready.
      </p>
      <button type="button" onClick={add} disabled={busy || done} data-testid="golf-pack-add-btn"
        className="mt-4 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[0.7rem] uppercase tracking-[0.22em] transition-[opacity,transform] duration-200 active:scale-95 disabled:opacity-60"
        style={{ background: done ? "transparent" : GOLD, color: done ? GOLD : "#0d1f3a", border: `1px solid ${GOLD}` }}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : done ? <Check size={14} /> : <Package size={14} />}
        {done ? "All in your library" : s.in_library ? `Add the other ${s.total - s.in_library}` : "Add all to my library"}
      </button>
      {msg && <p className="mt-2 text-xs" style={{ color: "rgba(245,236,217,0.72)" }} data-testid="golf-pack-msg">{msg}</p>}
    </div>
  );
};
